import { memo } from 'react';
import { BarChartOutlined, ReloadOutlined } from '@ant-design/icons';

interface AnalyticsHeaderProps {
  loading: boolean;
  onRefresh: () => void;
}

const AnalyticsHeader = memo(({ loading, onRefresh }: AnalyticsHeaderProps) => (
  <div className="flex items-center justify-between px-6 py-5 border-b border-blue-50">
    <div className="flex items-center gap-3">
      <div
        className="w-10 h-10 rounded-xl flex items-center justify-center
                   bg-gradient-to-br from-orange-700 via-orange-600 to-orange-400
                   text-white text-lg shadow-md"
      >
        <BarChartOutlined />
      </div>
      <div>
        <h3 className="text-base font-bold text-blue-950 m-0">
          Google Analytics Avancées
        </h3>
        <p className="text-xs text-slate-400 m-0">
          Analytics complètes avec métriques avancées
        </p>
      </div>
    </div>

    <button
      onClick={onRefresh}
      disabled={loading}
      title="Actualiser"
      className="w-10 h-10 flex items-center justify-center rounded-xl
                 bg-blue-50 border border-blue-100 text-blue-500 cursor-pointer
                 hover:bg-blue-100 disabled:opacity-50 transition-all duration-200"
    >
      <ReloadOutlined className={loading ? 'animate-spin' : ''} />
    </button>
  </div>
));

AnalyticsHeader.displayName = 'AnalyticsHeader';

export default AnalyticsHeader;